import { use_effect } from '@/hooks/_base/use_effect';
import { service_drop } from './SERVICE__drop';

export function WATCHER__drag_and_drop() {
  use_effect(() => {
    function on_drag_end(e: DragEvent) {
      service_drop.resolve_drop(e.clientX, e.clientY);
    }

    document.addEventListener('dragend', on_drag_end, true);

    return () => void document.removeEventListener('dragend', on_drag_end, true);
  }, []);

  return null;
}
